<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'" [navigation]="navigation.default" [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex items-center w-full p-4 pl-6">
            <!-- Logo -->
            <div class="flex items-center justify-center">
                <a (click)="goHome()" class="clickable">
                    <img *ngIf="logoUrl" [src]="logoUrl" alt="Logo" class="sidebar-logo mr-4 rounded-2xl">
                </a>
            </div>
        </div>
    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationFooter>
        <div class="flex flex-col py-2 items-center opacity-50">
            <!-- <img *ngIf="logoUrl" [src]="logoUrl" alt="Logo" class="sidebar-logo"> -->
            <!--  <img
                class="max-w-36"
                src="assets/images/logo/logo-text-on-dark.svg">  -->
            <div class="text-slate-900 font-bold text-sm">{{drakeName}}</div>
            <div class="text-slate-900 text-xs">powered by DRAKE v{{drakeVersion}}</div>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>

        </button>

        <app-drake-toolbar [toolbarConfig]="drakeSharedService.currentPageData?.pageToolbar"></app-drake-toolbar>

        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <button *ngIf="showDropdownToolbar && !companyIsPro && subscribeCompanyUserId" type="button"
                class="inline-flex items-center h-7 px-3 rounded-full border border-amber-500 bg-transparent text-amber-600 text-xs font-semibold tracking-normal shadow-sm hover:bg-amber-50 dark:text-amber-300 dark:hover:bg-amber-500/10"
                (click)="goToSubscribe()">
                ABBONATI
            </button>
            <button *ngIf="showDropdownToolbar" type="button"
                (click)="openCompanySelectorModal(companySelectorTemplate)"
                class="w-[24rem] h-10 px-4 flex items-center justify-between bg-card hover:bg-gray-50 dark:hover:bg-slate-800 border border-gray-300 dark:border-slate-700 rounded-lg text-sm text-slate-800 dark:text-slate-100 transition-colors shadow-sm focus:outline-none focus:ring-1 focus:ring-primary">
                <div class="flex items-center truncate">
                    <mat-icon
                        [svgIcon]="companySelected === 'STUDIO' ? 'heroicons_outline:home' : 'heroicons_outline:building-office'"
                        class="mr-2 text-slate-400 icon-size-5 shrink-0"></mat-icon>
                    <span class="font-medium truncate text-left">{{getSelectedCompanyText()}}</span>
                </div>
                <div class="flex items-center space-x-1 shrink-0 ml-2">
                    <span *ngIf="companyIsPro"
                        class="px-1.5 py-0.5 rounded text-[9px] font-bold bg-amber-500 text-white leading-none shadow-sm mr-1">PRO</span>
                    <mat-icon [svgIcon]="'heroicons_outline:chevron-down'"
                        class="text-slate-400 icon-size-4"></mat-icon>
                </div>
            </button>
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <!--<search [appearance]="'bar'"></search>-->
            <languages></languages>
            <!-- <shortcuts></shortcuts> -->

            <app-help-toolbar *ngIf="drakeHelp"></app-help-toolbar>
            <!-- Components -->

            <div class="flex items-center ml-auto">
                <notifications></notifications>
                <user [showAvatar]="false"></user>
            </div>

        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <!-- <div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
    </div> -->

</div>

<!-- Quick chat -->
<quick-chat #quickChat="quickChat" *ngIf="modules?.chat"></quick-chat>

<!-- Company selector modal template -->
<ng-template #companySelectorTemplate>
    <div
        class="flex flex-col w-full h-full max-h-[85vh] p-6 bg-card text-default rounded-2xl shadow-xl overflow-hidden dialog-container">
        <!-- Title and Close Button -->
        <div class="flex items-center justify-between pb-4 border-b border-gray-200 dark:border-gray-800">
            <h2 class="text-lg font-bold tracking-tight text-slate-800 dark:text-slate-100 flex items-center">
                <mat-icon [svgIcon]="'heroicons_outline:building-office'" class="mr-2 text-primary"></mat-icon>
                Seleziona Azienda
            </h2>
            <button mat-icon-button (click)="closeCompanySelectorModal()"
                class="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200">
                <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>

        <!-- Search and Sort Controls -->
        <div class="py-4 space-y-3">
            <!-- Search Input -->
            <div class="relative flex items-center">
                <mat-icon class="absolute left-3 text-slate-400 icon-size-5"
                    [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
                <input type="text" [(ngModel)]="searchTerm" placeholder="Cerca per nome azienda..."
                    class="w-full pl-10 pr-10 py-2 bg-gray-50 dark:bg-slate-900 border border-gray-300 dark:border-slate-800 rounded-lg text-sm text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
                <button *ngIf="searchTerm"
                    class="absolute right-3 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200"
                    (click)="searchTerm = ''">
                    <mat-icon [svgIcon]="'heroicons_outline:x-mark'" class="icon-size-4"></mat-icon>
                </button>
            </div>

            <!-- Sort Selector -->
            <div class="flex items-center justify-between text-xs text-slate-500 dark:text-slate-400">
                <span class="font-medium">Ordina per:</span>
                <div class="flex space-x-1">
                    <button class="px-3 py-1 rounded transition-colors" [ngClass]="{
                                'bg-primary text-white': sortBy === 'default',
                                'bg-gray-100 dark:bg-slate-800 hover:bg-gray-200 dark:hover:bg-slate-700 text-slate-800 dark:text-slate-100': sortBy !== 'default'
                            }" (click)="sortBy = 'default'">
                        Predefinito
                    </button>
                    <button class="px-3 py-1 rounded transition-colors" [ngClass]="{
                                'bg-primary text-white': sortBy === 'alphabetical',
                                'bg-gray-100 dark:bg-slate-800 hover:bg-gray-200 dark:hover:bg-slate-700 text-slate-800 dark:text-slate-100': sortBy !== 'alphabetical'
                            }" (click)="sortBy = 'alphabetical'">
                        Nome A-Z
                    </button>
                    <button class="px-3 py-1 rounded transition-colors" [ngClass]="{
                                'bg-primary text-white': sortBy === 'pro',
                                'bg-gray-100 dark:bg-slate-800 hover:bg-gray-200 dark:hover:bg-slate-700 text-slate-800 dark:text-slate-100': sortBy !== 'pro'
                            }" (click)="sortBy = 'pro'">
                        Abbonati Prima
                    </button>
                </div>
            </div>
        </div>

        <!-- Companies List -->
        <div class="flex-auto max-h-[50vh] overflow-y-auto pr-1 space-y-1 custom-scrollbar">
            <div *ngFor="let company of sortedAndFilteredCompanies" (click)="selectCompanyFromModal(company.value)"
                class="group flex items-center justify-between p-3 rounded-lg border border-transparent cursor-pointer transition-all hover:bg-gray-50 dark:hover:bg-slate-850 hover:border-gray-200 dark:hover:border-slate-800"
                [ngClass]="{
                    'bg-primary-50 border-primary-200 dark:bg-primary-950/20 dark:border-primary-800/40': companySelected === company.value
                }">

                <div class="flex items-center space-x-3 flex-1 min-w-0">
                    <div class="shrink-0 flex items-center justify-center w-8 h-8 rounded-full bg-slate-100 dark:bg-slate-800 text-slate-500 dark:text-slate-400 group-hover:bg-white dark:group-hover:bg-slate-750 transition-colors"
                        [ngClass]="{
                             'bg-primary-100 text-primary dark:bg-primary-900/30': companySelected === company.value
                         }">
                        <mat-icon
                            [svgIcon]="company.value === 'STUDIO' ? 'heroicons_outline:home' : 'heroicons_outline:building-office'"
                            class="icon-size-5"></mat-icon>
                    </div>

                    <div class="flex flex-col flex-1 min-w-0">
                        <span class="truncate text-sm font-semibold text-slate-700 dark:text-slate-200" [ngClass]="{
                                  'text-primary-700 dark:text-primary-300': companySelected === company.value
                              }">
                            {{company.text}}
                        </span>
                        <span *ngIf="company.value !== 'STUDIO'"
                            class="truncate text-[10px] text-slate-400 dark:text-slate-550">
                            {{ company.partitaIva ? 'P.IVA: ' + company.partitaIva : 'ID: ' + company.value }}
                        </span>
                    </div>
                </div>

                <div class="flex items-center space-x-2 shrink-0">
                    <!-- Selected Checkmark -->

                    <mat-icon *ngIf="companySelected === company.value" [svgIcon]="'heroicons_outline:check'"
                        class="text-primary icon-size-5"></mat-icon>
                    <!-- Pro Badge -->
                    <span *ngIf="company.isPro"
                        class="px-2 py-0.5 rounded text-[10px] font-bold bg-amber-500 text-white shadow-sm border border-amber-400">
                        PRO
                    </span>

                </div>
            </div>

            <!-- Empty State -->
            <div *ngIf="sortedAndFilteredCompanies.length === 0"
                class="flex flex-col items-center justify-center py-8 text-center text-slate-400 dark:text-slate-500">
                <mat-icon [svgIcon]="'heroicons_outline:building-office'"
                    class="icon-size-12 mb-2 text-slate-300 dark:text-slate-700"></mat-icon>
                <p class="text-sm">Nessuna azienda trovata.</p>
            </div>
        </div>
    </div>
</ng-template>